import './_jquery-globals.js';

import './_global';
import './_blog';
import './_watchlist';
import './_watch-and-notifications';
import './_product-finder';
import './_conditional-checkbox';
import './_location-finder';
import './_downloadcenter';
import './_alert';
import './_print';
import './_jobvacancies';
import './_search';
import './_piwikpro';
import './_quickwinbinding-v1.0.js';

import EstaticoApp from './helpers/estaticoapp';
import { moveModals, preventModalTriggerFormSubmit } from './_utils';

document.dispatchEvent(new Event('jquery-load'));

const app = new EstaticoApp();
app.start();
moveModals();
preventModalTriggerFormSubmit();
